import {createContext, useContext} from 'react'

const CustomerServicePageConfigContext = createContext(null)

export const CustomerServicePageConfigProvider = CustomerServicePageConfigContext.Provider

/**
 * Return the current customer service page config.
 *
 * @return {Object}
 */
const useCustomerServicePageConfig = () => {
    const context = useContext(CustomerServicePageConfigContext)

    if (!context) {
        throw new Error(
            'useCustomerServicePageConfig must be used within a CustomerServicePageConfigProvider'
        )
    }

    return context
}

export default useCustomerServicePageConfig
